import angular from 'angular';

angular.module('cloudX').directive('affixer', [
  '$window',
  function($window) {
    return {
      restrict: 'A',
      link: function($scope, $element, attributes) {
        var win = angular.element($window);
        var initOffset = $element.offset();
        var initWidth = $element.outerWidth();
        var initHeight = $element.outerHeight();
        var minTop = $('nav.navbar').height() + 20;
        var lastScrollTop = 0;

        function affixElement() {
          if ($window.pageYOffset > initOffset.top) {
            if (!$element.hasClass('affix')) {
              initHeight = $element.outerHeight();
              initWidth = $element.outerWidth();
              $element.css('top', minTop + 'px');
              $element.css('width', initWidth + 'px');
              $element.css('overflow', 'visible');
              $element.css('bottom', '0');
            } else if (initHeight > $window.innerHeight - minTop) {
              if (lastScrollTop > $window.pageYOffset) {
                if ($element.position().top < minTop) {
                  $element.css(
                    'top',
                    $element.position().top + (lastScrollTop - $window.pageYOffset) + 'px',
                  );
                }
              } else {
                if (initHeight + $element.position().top > $window.innerHeight - minTop) {
                  $element.css(
                    'top',
                    $element.position().top + (lastScrollTop - $window.pageYOffset) + 'px',
                  );
                }
              }
            }
            $element.addClass('affix');
          } else {
            $element.removeClass('affix');
            $element.css('top', '');
            $element.css('width', '');
            $element.css('bottom', '');
            $element.css('overflow', '');
          }
          lastScrollTop = $window.pageYOffset;
        }

        function resize() {
          $element.removeClass('affix');
          affixElement();
        }

        $scope.$on('$destroy', function() {
          win.unbind('scroll', affixElement);
          win.unbind('resize', resize);
        });
        win.bind('scroll', affixElement);
        win.bind('resize', resize);
      },
    };
  },
]);
